<section class="hero">
  <video
    #heroVideo
    preload="auto"
    autoplay
    muted
    loop
    playsinline
    class="hero-video"
    src="public/video/hero-section.mp4"
  ></video>
  <div class="hero-overlay"></div>

  <div class="hero-content container text-center text-white w-lg-75 w-100">
    <h1 class="title display-5 fw-bold">Unlock Your Business Potential</h1>

    <p class="subtitle lead text-center mt-3">
      Transform the way you work and achieve unprecedented growth. Our tailored
      software solutions are designed to streamline your processes, boost
      efficiency, and drive tangible results.
    </p>

    <div class="container mt-5">
      <div class="row justify-content-center">
        <div class="col-md-6">
          <div
            [formGroup]="contactForm"
            class="subscription-wrapper d-flex align-items-center p-2"
          >
            <input
              class="form-control bg-transparent border-0 text-white shadow-none ps-4"
              placeholder="Enter your email"
              formControlName="senderEmail"
              [class.is-invalid]="
                isSubmitted && getContactControl('senderEmail')?.invalid
              "
            />

            <button
              (click)="onSubmit()"
              class="btn btn-contact px-4 py-2"
              [class.btn-blue]="isTypingFinished"
              type="button"
            >
              Contact Us
            </button>
          </div>

          @if (isSubmitted && getContactControl('senderEmail')?.invalid) {
          <div class="text-danger mt-2 ps-2" style="font-size: 0.85rem">
            @if (getContactControl('senderEmail')?.errors?.['required']) {
            <small class="d-block">Email address is required.</small>
            } @if (getContactControl('senderEmail')?.errors?.['email'] ||
            getContactControl('senderEmail')?.errors?.['pattern']) {
            <small class="d-block">Please enter a valid email.</small>
            }
          </div>
          }
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Software Solutions section -->
<section class="software-solutions">
  <div class="container custom-container text-center">
    <h2 class="section-heading text-white fs-1 text-lg-center text-start">
      {{ "solutions.title1" | translate }}
      <span class="d-block">{{ "solutions.title2" | translate }}</span>
    </h2>

    <section
      class="row flex-column flex-lg-row justify-content-center align-items-center gap-5 mt-5 gx-4 gy-4 service-box"
    >
      <div class="col-12 col-lg-4 col-md-12">
        <div></div>
        <p>{{ "solutions.paragh1" | translate }}</p>
      </div>

      <div class="col-12 col-lg-4 col-md-12">
        <div></div>
        <p>{{ "solutions.paragh2" | translate }}</p>
      </div>

      <div class="col-12 col-lg-4 col-md-12">
        <div></div>
        <p>{{ "solutions.paragh3" | translate }}</p>
      </div>
    </section>
  </div>
</section>

<!-- who we are section -->
<section class="who-we-are">
  <div class="container">
    <div class="row d-flex justify-content-center align-items-center pb-4">
      <div class="col-12 col-lg-6 text-start">
        <h2 class="text-white fs-1 mb-1">{{ "whoWeAre.title" | translate }}</h2>
        <p class="text-white">
          {{ "whoWeAre.details" | translate }}
        </p>
      </div>

      <div class="col-12 col-lg-6">
        <img
          src="/public/data/frame2.png"
          alt="Who We Are"
          class="img-fluid rounded-4 w-100"
        />
      </div>
    </div>
  </div>
</section>

<section class="contact">
  <app-contact-us-form />
</section>

@if (showSuccessModal) {
<app-success-modal (close)="showSuccessModal = false"></app-success-modal>
}
